import { render, staticRenderFns } from "./FrameInfo.vue?vue&type=template&id=6e5b8966"
import script from "./FrameInfo.vue?vue&type=script&lang=js"
export * from "./FrameInfo.vue?vue&type=script&lang=js"
import style0 from "./FrameInfo.vue?vue&type=style&index=0&id=6e5b8966&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports